import React from 'react';

const LineIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="200" height="2" viewBox="0 0 245 2" fill="none">
    <path d="M1 1H244" stroke="#98A2B3" strokeLinecap="round" strokeDasharray="5 5" />
  </svg>
);

export default LineIcon;
